import {
  CLEAR,
  UPDATE_SELECT_CLIENT,
  UPDATE_SEARCH_VALUE,
  CLEAR_CLIENT_LIST,
  CHANGE_CURRENT_PAGE,
  CHANGE_PAGE_SIZE,
  CHANGE_SEARCH_VALUE,
  CHANGE_SELECT_CLIENT,
  UPDATE_PAGE_SIZE,
  UPDATE_COUNT_SIZE,
  UPDATE_CURRENT_PAGE,
  UPDATE_CLIENT_LIST,
  CHANGE_EDIT,
  UPDATE_EDIT,
  FETCH_CLIENTS,
  FETCH_CLIENTS_START,
  FETCH_CLIENTS_SUCCESS,
  FETCH_CLIENTS_ERROR,
  PATCH_CLIENT,
  PATCH_CLIENT_START,
  PATCH_CLIENT_SUCCESS,
  PATCH_CLIENT_ERROR,
} from './constants'
import {
  buildAsyncAction,
} from 'containers/Async/actions'

const clear = () => ({ type: CLEAR })
const clearClientList = () => ({ type: CLEAR_CLIENT_LIST })
const changeSearchValue = (value) => ({ type: CHANGE_SEARCH_VALUE, value })
const changePageSize = (size) => ({ type: CHANGE_PAGE_SIZE, size })
const changeSelectClient = (id) => ({ type: CHANGE_SELECT_CLIENT, id })
const updateSelectClient = (id) => ({ type: UPDATE_SELECT_CLIENT, id })
const updateSearchValue = (value) => ({ type: UPDATE_SEARCH_VALUE, value })
const updateClientList = (clients) => ({ type: UPDATE_CLIENT_LIST, clients })
const updatePageSize = (size) => ({ type: UPDATE_PAGE_SIZE, size })
const updateCountSize = (count) => ({ type: UPDATE_COUNT_SIZE, count })
const updateCurrentPage = (page) => ({ type: UPDATE_CURRENT_PAGE, page })
const changeEdit = (enable) => ({ type: CHANGE_EDIT, enable })
const updateEdit = (enable) => ({ type: UPDATE_EDIT, enable })
const incrementPage = () => ({ type: CHANGE_CURRENT_PAGE, value: 1 })
const decrementPage = () => ({ type: CHANGE_CURRENT_PAGE, value: -1 })

/* Async Calls */
const fetchClients = () => ({ type: FETCH_CLIENTS })
const fetchClientsStart = () => ({ type: FETCH_CLIENTS_START })
const fetchClientsSuccess = () => ({ type: FETCH_CLIENTS_SUCCESS })
const fetchClientsError = (error) => ({ type: FETCH_CLIENTS_ERROR, error })
const startFetchClientsAsync = buildAsyncAction(
  FETCH_CLIENTS,
  FETCH_CLIENTS_START,
  [FETCH_CLIENTS_SUCCESS, FETCH_CLIENTS_ERROR]
)

const patchClient = (value) => ({ type: PATCH_CLIENT, value })
const patchClientStart = () => ({ type: PATCH_CLIENT_START })
const patchClientSuccess = () => ({ type: PATCH_CLIENT_SUCCESS })
const patchClientError = (error) => ({ type: PATCH_CLIENT_ERROR, error })
const startPatchClientAsync = buildAsyncAction(
  PATCH_CLIENT,
  PATCH_CLIENT_START,
  [PATCH_CLIENT_SUCCESS, PATCH_CLIENT_ERROR]
)

export {
  incrementPage,
  decrementPage,
  changePageSize,
  changeSearchValue,
  changeSelectClient,
  updateSelectClient,
  updatePageSize,
  updateCountSize,
  updateCurrentPage,
  updateClientList,
  updateSearchValue,
  changeEdit,
  updateEdit,
  clearClientList,
  fetchClients,
  fetchClientsStart,
  fetchClientsSuccess,
  fetchClientsError,
  startFetchClientsAsync,
  patchClient,
  patchClientStart,
  patchClientSuccess,
  patchClientError,
  startPatchClientAsync,
  clear,
}
